module.exports = __webpack_public_path__ + "img/脚型.1384d6dc.png";